import { access } from './access';
import { adapters } from './adapters';
import { aiQuality } from './ai-quality';
import { billing } from './billing';
import { commercial } from './commercial';
import { dashboard } from './dashboard';
import { merchantDetail } from './merchant-detail';
import { merchantTabs } from './merchant-tabs';
import { merchants } from './merchants';
import { packs } from './packs';
import { shell } from './shell';
import { support } from './support';
import { system } from './system';

// The admin panel's screen strings (WS-17), keyed admin.<area>.<key> (UI architecture §10).
export const admin = {
  shell,
  access,
  dashboard,
  merchants,
  merchantDetail,
  merchantTabs,
  support,
  commercial,
  billing,
  packs,
  adapters,
  aiQuality,
  system,
} as const;
